import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {environmentURLs} from '../../../../src/components/common/CaptureEnvironment';

const initialState = {
  systemInfoPending: true,
  systemInfoErrored: false,
  dmsAccountsSupport: {},
  privacyProtectionSupport: {},
  apiFieldSelections: {},
};

export const getAPISystemInfo = createAsyncThunk(
  'getAPISystemInfo',
  async ({apis, appId, token} ) => {
    const response = await axios({
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/v2/systemInfo`,
      data: {
        apis,
        appId,
      }
    });
    return {
      ...response,
      apis,
    };
  }
);

export const Configurations = createSlice({
  name: 'Configurations',
  initialState,
  reducers: {
    resetConfigurations: () => initialState,
  },
  extraReducers: {
    [getAPISystemInfo.fulfilled]: (state, action) =>{
      state.systemInfoPending = false;
      state.systemInfoErrored = false;
      if (action.payload) {
        const apiFieldSelections = {};
        const cppSupported = {};
        const { data: { apiDetails, privacyProtectionSupported, verticalScopingApisList, dealerApiPreferences = {} }} = action.payload;
        let dmsAccountsSupportPerAPI = {};
        for (const apiId in apiDetails) {
          dmsAccountsSupportPerAPI[apiId.replace('api-v2-', '')] = apiDetails[apiId][0];
        };
        state.dmsAccountsSupport = dmsAccountsSupportPerAPI;
        for (const apiId in privacyProtectionSupported) {
          cppSupported[apiId.replace('api-v2-', '')] = privacyProtectionSupported[apiId];
        };
        state.privacyProtectionSupport = cppSupported;
        const fieldLimitingEnabledVSApis = verticalScopingApisList?.filter(api => api.fieldLimiting);
        fieldLimitingEnabledVSApis?.length && fieldLimitingEnabledVSApis.forEach(apiData => {
            apiFieldSelections[apiData?.id?.replace('api-v2-', '')] = {
                apiType: apiData.apiType,
                apiName: apiData.name,
                apiFieldSelections: apiData.apiFieldSelections,
                manualSelectionFields: apiData.manualSelectionFields,
            };
        }); 
        state.apiFieldSelections = apiFieldSelections;
        state.dealerApiPreferences = Object.entries(dealerApiPreferences).reduce((acc, [apiId, apiPrefs]) => {
          acc[apiId.replace('api-v2-', '')] = apiPrefs;
          return acc;
        }, {});
      }
    },
    [getAPISystemInfo.pending]: state => {
      state.systemInfoPending = true;
      state.systemInfoErrored = null;
    },
    [getAPISystemInfo.rejected]: (state, { error }) =>{
      state.systemInfoPending = false;
      state.systemInfoErrored = error;
    }
  },
});

export const {
  disableNext,
  resetConfigurations,
  requestIntegrationStatusChange,
} = Configurations.actions;

export default Configurations.reducer;
